<template lang="pug">
  .login-skeleton
    .heading-bar
    login-forms-skeleton
</template>
<script setup lang="ts">
import LoginFormsSkeleton from './login-forms-skeleton.vue'
</script>
<style lang="scss" scoped>
@keyframes skeleton-loading {
  0% { background-color: $color-gray; }
  100% { background-color: $color-gray-light; }
}

.heading-bar {
  border-radius: $border-width-thick;
  animation: skeleton-loading 0.8s linear infinite alternate;
  height: $size-xxl;
  width: 320px;
  max-width: 100%;
  margin: 0 auto $space-s 0;
}
</style>
